import type { OrganizationResponseDto } from '@trellis/api'
import confetti from 'canvas-confetti'
import { toast } from 'sonner'

import {
  useClaimOnboardingCelebrationMutation,
  useOrganization,
} from '@/hooks/useOrganization'
import { pushEvent } from '@/lib/analytics'
import { computeOverallCompleteness } from '@/lib/organization-completeness'

interface CelebrateOverrides {
  organization?: OrganizationResponseDto | null
}

export function useCelebrateOnboardingIfComplete() {
  const { data: organizationResult } = useOrganization()
  const { mutateAsync: claim } = useClaimOnboardingCelebrationMutation()

  return async function celebrateIfComplete(
    overrides: CelebrateOverrides = {},
  ): Promise<void> {
    const organization = overrides.organization ?? organizationResult?.data ?? null

    const completeness = computeOverallCompleteness(organization)
    if (!completeness.isComplete) return

    const result = await claim()
    if (result.error || !result.data?.claimed) return

    pushEvent('onboarding_completed')
    void confetti({ particleCount: 150, spread: 70, origin: { y: 0.6 } })
    toast.success('🎉 Setup complete — your business profile is all set up!')
  }
}
